import React from "react";
import { StaticImage } from "gatsby-plugin-image";

// Doctor data with StaticImage components
export const DOCTORS_DATA = [
  {
    id: 1,
    name: "Dr. Riyas Mohamed",
    experience: "27+ years Experience",
    credentials: "MBBS, MD, MBA, PGDAEC, AALM, ACCAM",
    bgColor: "#E8D4F8",
    specialization: "Lifestyle Medicine",
    location: "Chennai",
    patientsTreated: "20,000+",
    image: (
      <StaticImage
        src="../../../images/doctor/riyas.png"
        alt="Dr. Riyas Mohamed"
        placeholder="blurred"
        loading="lazy"
        objectFit="cover"
      />
    ),
    detailImage: (
      <StaticImage
        src="../../../images/doctor/riyas-detail.png"
        alt="Dr. Riyas Mohamed"
        placeholder="blurred"
        loading="lazy"
        objectFit="cover"
      />
    ),
  },
  {
    id: 2,
    name: "Dr. L. Sreenivasa Murthy",
    experience: "21+ years Experience",
    credentials: "MBBS, MD",
    bgColor: "#B8E6E6",
    specialization: "Senior Consulting Physician and Diabetologist",
    location: "Bangalore",
    patientsTreated: "25,000+",
    image: (
      <StaticImage
        src="../../../images/doctor/sreenivasa.png"
        alt="Dr. L. Sreenivasa Murthy"
        placeholder="blurred"
        loading="lazy"
        objectFit="cover"
      />
    ),
    detailImage: (
      <StaticImage
        src="../../../images/doctor/sreenivasa-detail.png"
        alt="Dr. L. Sreenivasa Murthy"
        placeholder="blurred"
        loading="lazy"
        objectFit="cover"
      />
    ),
  },
  {
    id: 3,
    name: "Dr. Mohsin Wali",
    experience: "50+ years Experience",
    credentials:
      "MBBS, MD (Medicine & Cardiology), FACC, MBA in Healthcare Services",
    bgColor: "#4A3A8C",
    specialization:
      "Internal Medicine, General Physician, Cardiologist, Diabetologist",
    location: "New Delhi",
    patientsTreated: "25,000+",
    image: (
      <StaticImage
        src="../../../images/doctor/mohsin.png"
        alt="Dr. Mohsin Wali"
        placeholder="blurred"
        loading="lazy"
        objectFit="cover"
      />
    ),
    detailImage: (
      <StaticImage
        src="../../../images/doctor/mohsin-detail.png"
        alt="Dr. Mohsin Wali"
        placeholder="blurred"
        loading="lazy"
        objectFit="cover"
      />
    ),
  },
  {
    id: 4,
    name: "Dr. Suresh Damodharan",
    experience: "25+ years Experience",
    credentials:
      "MBBS, MD(Gen Med), CCST (Internal Medicine) (London), CCST (Diabetology and Endocrinology) (London)",
    bgColor: "#F5C7A3",
    specialization: "Endocrinologist, Internal Medicine, Sexologist",
    location: "Coimbatore",
    patientsTreated: "20,000+",
    image: (
      <StaticImage
        src="../../../images/doctor/suresh.png"
        alt="Dr. Suresh Damodharan"
        placeholder="blurred"
        loading="lazy"
        objectFit="cover"
      />
    ),
    detailImage: (
      <StaticImage
        src="../../../images/doctor/suresh-detail.png"
        alt="Dr. Suresh Damodharan"
        placeholder="blurred"
        loading="lazy"
        objectFit="cover"
      />
    ),
  },
  {
    id: 5,
    name: "Dr. Vivekanandan Kalyanasundaram",
    experience: "20+ years Experience",
    credentials: "MBBS, MRCS, FRCS",
    bgColor: "#FFE5CC",
    specialization: "Liver Transplant Surgeon",
    location: "Chennai",
    patientsTreated: "15,000+",
    image: (
      <StaticImage
        src="../../../images/doctor/vivekanandan.png"
        alt="Dr. Vivekanandan Kalyanasundaram"
        placeholder="blurred"
        loading="lazy"
        objectFit="cover"
      />
    ),
    detailImage: (
      <StaticImage
        src="../../../images/doctor/vivekananda-detail.png"
        alt="Dr. Vivekanandan Kalyanasundaram"
        placeholder="blurred"
        loading="lazy"
        objectFit="cover"
      />
    ),
  },
  {
    id: 6,
    name: "Dr. Ashutosh Shukla",
    experience: "32+ years Experience",
    credentials: "MD, FCAP (Senior Consultant Physician)",
    bgColor: "#D4E8F8",
    specialization: "Diabetology and Internal Medicine",
    location: "Mumbai",
    patientsTreated: "12,000+",
    image: (
      <StaticImage
        src="../../../images/doctor/ashutosh-shukla.png"
        alt="Dr. Ashutosh Shukla"
        placeholder="blurred"
        loading="lazy"
        objectFit="cover"
      />
    ),
    detailImage: (
      <StaticImage
        src="../../../images/doctor/ashutosh-detail.png"
        alt="Dr. Ashutosh Shukla"
        placeholder="blurred"
        loading="lazy"
        objectFit="cover"
      />
    ),
  },
  {
    id: 7,
    name: "Dr. Rajiv Kovil",
    experience: "30+ years Experience",
    credentials: "MBBS, Diploma in Diabetology",
    bgColor: "#F8E8D4",
    specialization: "General Physician, Diabetologist",
    location: "Mumbai",
    patientsTreated: "20,000+",
    image: (
      <StaticImage
        src="../../../images/doctor/rajiv-kovil.png"
        alt="Dr. Rajiv Kovil"
        placeholder="blurred"
        loading="lazy"
        objectFit="cover"
      />
    ),
    detailImage: (
      <StaticImage
        src="../../../images/doctor/rajiv-detail.png"
        alt="Dr. Rajiv Kovil"
        placeholder="blurred"
        loading="lazy"
        objectFit="cover"
      />
    ),
  },
  {
    id: 8,
    name: "Dr. Rahul Baxi",
    experience: "12+ years Experience",
    credentials: "MD",
    bgColor: "#A9D7E1",
    specialization: "Diabetology and Internal Medicine",
    location: "Mumbai",
    patientsTreated: "15,000+",
    image: (
      <StaticImage
        src="../../../images/doctor/rahul-baxi.png"
        alt="Dr. Rahul Baxi"
        placeholder="blurred"
        loading="lazy"
        objectFit="cover"
      />
    ),
    detailImage: (
      <StaticImage
        src="../../../images/doctor/rahul-detail2.png"
        alt="Dr. Rahul Baxi"
        placeholder="blurred"
        loading="lazy"
        objectFit="cover"
      />
    ),
  },
  {
    id: 9,
    name: "Dr. Ravi Shankar Erukulapati",
    experience: "20+ years Experience",
    credentials:
      "MBBS, DMRD, MRCP (UK), CCT (UK) (Diabetes, Endocrinology, and General Medicine)",
    specialization:
      "Senior Consultant Endocrinologist & Diabetologistdocrinology",
    location: "Hyderabad",
    patientsTreated: "25,000+",
    image: (
      <StaticImage
        src="../../../images/doctor/ravi-shankar.png"
        alt="Dr. Ravi Shankar Erukulapati"
        placeholder="blurred"
        loading="lazy"
        objectFit="cover"
      />
    ),
    detailImage: (
      <StaticImage
        src="../../../images/doctor/ravi-detail2.png"
        alt="Dr. Ravi Shankar Erukulapati"
        placeholder="blurred"
        loading="lazy"
        objectFit="cover"
      />
    ),
  },
  {
    id: 10,
    name: "Dr. Shashank Joshi",
    experience: "30+ years Experience",
    credentials: "MBBS, MD, DM (Gold Medals), FACE, FACP,  FRCP",
    bgColor: "#4A3A8C",
    specialization: "Endocrinologist and Diabetologist",
    location: "Mumbai",
    patientsTreated: "25,000+",
    image: (
      <StaticImage
        src="../../../images/doctor/shashank-joshi.png"
        alt="Dr. Shashank Joshi"
        placeholder="blurred"
        loading="lazy"
        objectFit="cover"
      />
    ),
    detailImage: (
      <StaticImage
        src="../../../images/doctor/shashank-detail2.png"
        alt="Dr. Shashank Joshi"
        placeholder="blurred"
        loading="lazy"
        objectFit="cover"
      />
    ),
  },
  {
    id: 11,
    name: "Dr. Krishna G. Seshadri",
    experience: "25+ years Experience",
    credentials: "MBBS, MD (Endocrinology)",
    bgColor: "#FFE5CC",
    specialization: "Endocrinologist",
    location: "Chennai",
    patientsTreated: "25,000+",
    image: (
      <StaticImage
        src="../../../images/doctor/krishna-seshadri.png"
        alt="Dr. Krishna G. Seshadri"
        placeholder="blurred"
        loading="lazy"
        objectFit="cover"
      />
    ),
    detailImage: (
      <StaticImage
        src="../../../images/doctor/krishna-detail2.png"
        alt="Dr. Krishna G. Seshadri"
        placeholder="blurred"
        loading="lazy"
        objectFit="cover"
      />
    ),
  },
  {
    id: 12,
    name: "Dr. Shambo S. Samajdar",
    experience: "15+ years Experience",
    credentials: "MBBS, MD, DM (Clinical Pharmacology)",
    bgColor: "#D4E8F8",
    specialization: "Clinical Pharmacologist",
    location: "Kolkata",
    patientsTreated: "25,000+",
    image: (
      <StaticImage
        src="../../../images/doctor/shambo.png"
        alt="Dr. Shambo S. Samajdar"
        placeholder="blurred"
        loading="lazy"
        objectFit="cover"
      />
    ),
    detailImage: (
      <StaticImage
        src="../../../images/doctor/shambo-d2.png"
        alt="Dr. Shambo S. Samajdar"
        placeholder="blurred"
        loading="lazy"
        objectFit="cover"
      />
    ),
  },
  {
    id: 13,
    name: "Dr. Leena Patankar",
    experience: "50+ years Experience",
    credentials:
      "MBBS, MD (Medicine & Cardiology), FACC, MBA in Healthcare Services",
    bgColor: "#F8E8D4",
    specialization: "Obstetrics & Gynecology",
    location: "Pune",
    patientsTreated: "20,000+",
    image: (
      <StaticImage
        src="../../../images/doctor/leena-patnakar.png"
        alt="Dr. Leena Patankar"
        placeholder="blurred"
        loading="lazy"
        objectFit="cover"
      />
    ),
    detailImage: (
      <StaticImage
        src="../../../images/doctor/leena-d2.png"
        alt="Dr. Leena Patankar"
        placeholder="blurred"
        loading="lazy"
        objectFit="cover"
      />
    ),
  },
  {
    id: 14,
    name: "Dr. Manish Sachdev",
    experience: "35+ years Experience",
    credentials:
      "MBBS, D.Diab, Fellowship in Diabetes, Diploma in Endocrinology",
    bgColor: "#E8D4F8",
    specialization: "Endocrinologist",
    location: "Thane",
    patientsTreated: "25,000+",
    image: (
      <StaticImage
        src="../../../images/doctor/manish-sachdev.png"
        alt="Dr. Manish Sachdev"
        placeholder="blurred"
        loading="lazy"
        objectFit="cover"
      />
    ),
    detailImage: (
      <StaticImage
        src="../../../images/doctor/manish-d2.png"
        alt="Dr. Manish Sachdev"
        placeholder="blurred"
        loading="lazy"
        objectFit="cover"
      />
    ),
  },
  {
    id: 15,
    name: "Dr. Ambrish Mithal",
    experience: "40+ years Experience",
    credentials: "MBBS, MD, DM (Endocrinology)",
    bgColor: "#B8E6E6",
    specialization: "Endocrinologist",
    location: "Gurgaon",
    patientsTreated: "25,000+",
    image: (
      <StaticImage
        src="../../../images/doctor/ambrish.png"
        alt="Dr. Ambrish Mithal"
        placeholder="blurred"
        loading="lazy"
        objectFit="cover"
      />
    ),
    detailImage: (
      <StaticImage
        src="../../../images/doctor/ambrish-d2.png"
        alt="Dr. Ambrish Mithal"
        placeholder="blurred"
        loading="lazy"
        objectFit="cover"
      />
    ),
  },
  {
    id: 16,
    name: "Dr. Arun Muthuvel",
    experience: "20+ years Experience",
    credentials: "MBBS, MS – OBGYN, MCh – Reproductive Medicine & Surgery",
    bgColor: "#4A3A8C",
    specialization:
      "MBBS, MS – OBGYN, MCh – Reproductive Medicine & Surgery, Advanced IVF – Boston IVF (Harvard University, USA), Natural Cycle IVF – Michigan IVF, USA, Andrology & Micro TESE for Azoospermia – University of Miami, USA, PGD IVF & Embryo Biopsy – Cleveland Clinic, USA",
    location: "Chennai",
    patientsTreated: "20,000+",
    image: (
      <StaticImage
        src="../../../images/doctor/arun.png"
        alt="Dr. Arun Muthuvel"
        placeholder="blurred"
        loading="lazy"
        objectFit="cover"
      />
    ),
    detailImage: (
      <StaticImage
        src="../../../images/doctor/arun-d2.png"
        alt="Dr. Arun Muthuvel"
        placeholder="blurred"
        loading="lazy"
        objectFit="cover"
      />
    ),
  },
  {
    id: 17,
    name: "Dr. Anuradha Kapoor",
    experience: "27+ years Experience",
    credentials:
      "MBBS and MD, PG Diploma in clinical endocrinology and Diabetes and Fellowship in Diabetes",
    bgColor: "#F5C7A3",
    specialization: "Diabetologist",
    location: "Mumbai",
    patientsTreated: "30,000+",
    image: (
      <StaticImage
        src="../../../images/doctor/anuradha.png"
        alt="Dr. Anuradha Kapoor"
        placeholder="blurred"
        loading="lazy"
        objectFit="cover"
      />
    ),
    detailImage: (
      <StaticImage
        src="../../../images/doctor/anuradha-d2.png"
        alt="Dr. Anuradha Kapoor"
        placeholder="blurred"
        loading="lazy"
        objectFit="cover"
      />
    ),
  },
  {
    id: 18,
    name: "Dr. Mala Dharmalingam",
    experience: "25+ years Experience",
    credentials: "MBBS, MD, DM",
    bgColor: "#FFE5CC",
    specialization: "Endocrinology",
    location: "Bangalore",
    patientsTreated: "25,000+",
    image: (
      <StaticImage
        src="../../../images/doctor/mala.png"
        alt="Dr. Mala Dharmalingam"
        placeholder="blurred"
        loading="lazy"
        objectFit="cover"
      />
    ),
    detailImage: (
      <StaticImage
        src="../../../images/doctor/mala-d2.png"
        alt="Dr. Mala Dharmalingam"
        placeholder="blurred"
        loading="lazy"
        objectFit="cover"
      />
    ),
  },
  {
    id: 19,
    name: "Dr. Darshana R",
    experience: "20+ years Experience",
    credentials: "MBBS, MD - General Medicine, DNB - General Medicine",
    bgColor: "#D4E8F8",
    specialization: "Internal Medicine",
    location: "Bangalore",
    patientsTreated: "20,000+",
    image: (
      <StaticImage
        src="../../../images/doctor/darshana.png"
        alt="Dr. Darshana R"
        placeholder="blurred"
        loading="lazy"
        objectFit="cover"
      />
    ),
    detailImage: (
      <StaticImage
        src="../../../images/doctor/darshana-d2.png"
        alt="Dr. Darshana R"
        placeholder="blurred"
        loading="lazy"
        objectFit="cover"
      />
    ),
  },
  {
    id: 20,
    name: "Dr. Shefali Trasi Nerurkar",
    experience: "40+ years Experience",
    credentials:
      "MD - Dermatology, MBBS, Diploma In Dermatology And Venerology And Leprosy (DDVL)",
    bgColor: "#F8E8D4",
    specialization: "Dermatology",
    location: "Mumbai",
    patientsTreated: "30,000+",
    image: (
      <StaticImage
        src="../../../images/doctor/shefali.png"
        alt="Dr. Shefali Trasi Nerurkar"
        placeholder="blurred"
        loading="lazy"
        objectFit="cover"
      />
    ),
    detailImage: (
      <StaticImage
        src="../../../images/doctor/shefali-d2.png"
        alt="Dr. Shefali Trasi Nerurkar"
        placeholder="blurred"
        loading="lazy"
        objectFit="cover"
      />
    ),
  },
  {
    id: 21,
    name: "Dr. Lokesh L V",
    experience: "20+ years Experience",
    credentials: "MBBS, MD - General Medicine, DM - Gastroenterology",
    bgColor: "#E8D4F8",
    specialization: "Gastroenterologist",
    location: "Bangalore",
    patientsTreated: "25,000+",
    image: (
      <StaticImage
        src="../../../images/doctor/lokesh.png"
        alt="Dr. Lokesh L V"
        placeholder="blurred"
        loading="lazy"
        objectFit="cover"
      />
    ),
    detailImage: (
      <StaticImage
        src="../../../images/doctor/lokesh-d2.png"
        alt="Dr. Lokesh L V"
        placeholder="blurred"
        loading="lazy"
        objectFit="cover"
      />
    ),
  },
  {
    id: 22,
    name: "Dr. Chennamchetty Vijay Kumar",
    experience: "20+ years Experience",
    credentials:
      "MD (Pulmonology), IDCC (Critical Care), FSM (Sleep Medicine), FCCP",
    bgColor: "#B8E6E6",
    specialization: "Pulmonary, Critical Care & Sleep Medicine",
    location: "Hyderabad",
    patientsTreated: "25,000+",
    image: (
      <StaticImage
        src="../../../images/doctor/vijay.png"
        alt="Dr. Chennamchetty Vijay Kumar"
        placeholder="blurred"
        loading="lazy"
        objectFit="cover"
      />
    ),
    detailImage: (
      <StaticImage
        src="../../../images/doctor/vijay-d2.png"
        alt="Dr. Chennamchetty Vijay Kumar"
        placeholder="blurred"
        loading="lazy"
        objectFit="cover"
      />
    ),
  },
  {
    id: 23,
    name: "Dr. Honey Satish Savla",
    experience: "7+ years Experience",
    credentials: "DNB INTERNAL MEDICINE,MBBS",
    bgColor: "#4A3A8C",
    specialization: "Internal Medicine",
    location: "Mumbai",
    patientsTreated: "10,000+",
    image: (
      <StaticImage
        src="../../../images/doctor/honey.png"
        alt="Dr. Honey Satish Savla"
        placeholder="blurred"
        loading="lazy"
        objectFit="cover"
      />
    ),
    detailImage: (
      <StaticImage
        src="../../../images/doctor/honey-d2.png"
        alt="Dr. Honey Satish Savla"
        placeholder="blurred"
        loading="lazy"
        objectFit="cover"
      />
    ),
  },
  {
    id: 24,
    name: "Dr. Ganga Kiran",
    experience: "15+ years Experience",
    credentials: "MBBS, MD",
    bgColor: "#F5C7A3",
    specialization: "Diabetologist",
    location: "Hyderabad",
    patientsTreated: "15,000+",
    image: (
      <StaticImage
        src="../../../images/doctor/ganga.png"
        alt="Dr. Ganga Kiran"
        placeholder="blurred"
        loading="lazy"
        objectFit="cover"
      />
    ),
    detailImage: (
      <StaticImage
        src="../../../images/doctor/ganga-d2.png"
        alt="Dr. Ganga Kiran"
        placeholder="blurred"
        loading="lazy"
        objectFit="cover"
      />
    ),
  },
  {
    id: 25,
    name: "Dr. Nandakishore Dukkipati",
    experience: "30+ years Experience",
    credentials: "M.D ,DABS, FASMBS, FMBS, FIBC",
    bgColor: "#FFE5CC",
    specialization: "Bariatric surgeon",
    location: "Hyderabad",
    patientsTreated: "25,000+",
    image: (
      <StaticImage
        src="../../../images/doctor/nandakishore.png"
        alt="Dr. Nandakishore Dukkipati"
        placeholder="blurred"
        loading="lazy"
        objectFit="cover"
      />
    ),
    detailImage: (
      <StaticImage
        src="../../../images/doctor/nandakishore-d2.png"
        alt="Dr. Nandakishore Dukkipati"
        placeholder="blurred"
        loading="lazy"
        objectFit="cover"
      />
    ),
  },
  {
    id: 26,
    name: "Dr. B V A Ranga Reddy",
    experience: "10+ years Experience",
    credentials: "MD,DM",
    bgColor: "#D4E8F8",
    specialization: "CARDIOLOGY",
    location: "Hyderabad",
    patientsTreated: "15,000+",
    image: (
      <StaticImage
        src="../../../images/doctor/ranga.png"
        alt="Dr. B V A Ranga Reddy"
        placeholder="blurred"
        loading="lazy"
        objectFit="cover"
      />
    ),
    detailImage: (
      <StaticImage
        src="../../../images/doctor/ranga-d2.png"
        alt="Dr. B V A Ranga Reddy"
        placeholder="blurred"
        loading="lazy"
        objectFit="cover"
      />
    ),
  },
  {
    id: 27,
    name: "Dr. Karunesh Kumar",
    experience: "30+ years Experience",
    credentials:
      "MBBS from Al-Ameen Medical College and an MD in General Medicine from Karnataka Institute of Medical Sciences (KIMS), with additional certification in Diabetes Education (CCEDM) from Indian Institutes of Public Health",
    bgColor: "#F8E8D4",
    specialization:
      "Diabetology, General Medicine, Family Physician, Preventive Healthcare",
    location: "Bangalore",
    patientsTreated: ".....",
    image: (
      <StaticImage
        src="../../../images/doctor/karunesh.png"
        alt="Dr. Karunesh Kumar"
        placeholder="blurred"
        loading="lazy"
        objectFit="cover"
      />
    ),
    detailImage: (
      <StaticImage
        src="../../../images/doctor/karunesh-d2.png"
        alt="Dr. Karunesh Kumar"
        placeholder="blurred"
        loading="lazy"
        objectFit="cover"
      />
    ),
  },
  {
    id: 28,
    name: "Dr. Vivek M S",
    experience: "20+ years Experience",
    credentials: "MBBS, PG - Diabetology (USA), ACMDC",
    bgColor: "#E8D4F8",
    specialization: "General Physician & Diabetologist",
    location: "Bangalore",
    patientsTreated: "20,000+",
    image: (
      <StaticImage
        src="../../../images/doctor/vivek.png"
        alt="Dr. Vivek M S"
        placeholder="blurred"
        loading="lazy"
        objectFit="cover"
      />
    ),
    detailImage: (
      <StaticImage
        src="../../../images/doctor/vivek-d2.png"
        alt="Dr. Vivek M S"
        placeholder="blurred"
        loading="lazy"
        objectFit="cover"
      />
    ),
  },
  {
    id: 29,
    name: "Dr. Ravi Gopal Varma",
    experience: "30+ years Experience",
    credentials: "MCH, MBBS , MS",
    bgColor: "#B8E6E6",
    specialization: "Neurosurgeon",
    location: "Bangalore",
    patientsTreated: "30,000+",
    image: (
      <StaticImage
        src="../../../images/doctor/ravi.png"
        alt="Dr. Ravi Gopal Varma"
        placeholder="blurred"
        loading="lazy"
        objectFit="cover"
      />
    ),
    detailImage: (
      <StaticImage
        src="../../../images/doctor/ravi-d2.png"
        alt="Dr. Ravi Gopal Varma"
        placeholder="blurred"
        loading="lazy"
        objectFit="cover"
      />
    ),
  },
];

export default DOCTORS_DATA;
